import React, { Suspense, useEffect, useState } from "react";

const SvgIconMap: Record<
  number,
  React.LazyExoticComponent<React.ComponentType<any>>
> = {
  1001: React.lazy(() => import("../../assets/icons/Wayfinding.svg")),
  1002: React.lazy(() => import("../../assets/icons/Info.svg")),
  // 1003: React.lazy(() => import("../../assets/icons/Overview.svg")),
  1004: React.lazy(() => import("../../assets/icons/Emergency.svg")),
  1005: React.lazy(() => import("../../assets/icons/GeneralPractitioner.svg")),
  1006: React.lazy(() => import("../../assets/icons/Medications.svg")),
  // client svgs
  2001: React.lazy(() => import("../../assets/icons/Pentax.svg")),
};

const SvgIcon = ({ id, width }: { id: number; width: string }) => {
  const [Icon, setIcon] = useState<React.LazyExoticComponent<
    React.ComponentType<any>
  > | null>(null);

  useEffect(() => {
    const loadIcon = SvgIconMap[id];
    if (loadIcon) {
      setIcon(loadIcon);
    }
  }, [id]);

  return Icon ? (
    <Suspense fallback={<></>}>
      <Icon width={width} />
    </Suspense>
  ) : null;
};

export default SvgIcon;
